<template>
  <v-container fluid class="admin-sasv-list">
    <v-row class="flex-grow-0">
      <v-col>
        <label class="text-h5">{{ $t('admin_sasv.duplicate_title') }}</label>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary"
               tile
               @click="refresh">
          <v-icon>fas fa-sync-alt</v-icon>
        </v-btn>
        <!--        <v-btn color="primary"-->
        <!--               @click="addMemberModalShown = true"-->
        <!--               v-if="$hasPermission('hkiarace.edit_member')">-->
        <!--          {{ $t('admin_user.add_user') }}-->
        <!--        </v-btn>-->
      </v-col>
    </v-row>
    <v-row class="flex-grow-0">
      <v-col>
        <v-text-field outlined
                      v-model="search"></v-text-field>
      </v-col>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col class="pa-0">
        <v-data-table :headers="headers"
                      :items="duplicates"
                      item-key="name"
                      :search="search"
                      :custom-filter="customFilter"
                      :items-per-page="-1"
                      hide-default-header
                      hide-default-footer
                      show-expand
                      :expanded.sync="expanded">
          <template v-slot:item.label="{item}">
            <label>{{ item.name }} ({{ item.count }})</label>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div class="pa-4">
                <v-data-table multi-sort
                              :items="item.sasv"
                              :items-per-page="item.sasv.length || 1"
                              :headers="sasvHeaders"
                              hide-default-footer>
                  <template #item.id_type="{value}">
                    {{ $t(`id_type.${value}`) }}
                  </template>
                  <template #item.validated_at="{value}">
                    {{ value ? $parseDate(value, 'yyyy-MM-dd') : '' }}
                  </template>
                  <template #item.status="{value}">
                    {{ $t(`sasv_status.${value}`) }}
                  </template>
                  <template v-slot:item.actions="{item}">
                    <v-container>
                      <v-row>
                        <v-col>
                          <v-tooltip top
                                     key="edit">
                            <template #activator="{on, attrs}">
                              <v-btn icon
                                     x-small
                                     v-on="on"
                                     v-bind="attrs"
                                     @click="onSasvEdit(item)">
                                <v-icon>fas fa-edit</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('edit') }}</span>
                          </v-tooltip>
                        </v-col>
                        <v-col v-if="item.status === 'APPROVED' && $hasPermission('sasv.suspend')">
                          <v-tooltip top
                                     key="disable">
                            <template #activator="{on, attrs}">
                              <v-btn icon
                                     x-small
                                     v-on="on"
                                     v-bind="attrs"
                                     @click="suspendItem(item)">
                                <v-icon>fas fa-lock</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('admin_sasv.suspend') }}</span>
                          </v-tooltip>
                        </v-col>
                        <v-col v-if="item.status === 'SUSPENDED' && $hasPermission('sasv.suspend')">
                          <v-tooltip top
                                     key="enable">
                            <template #activator="{on, attrs}">
                              <v-btn icon
                                     x-small
                                     v-on="on"
                                     v-bind="attrs"
                                     @click="unsuspendItem(item)">
                                <v-icon>fas fa-unlock</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('admin_sasv.unsuspend') }}</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                </v-data-table>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <EditSasvModal :shown="editSasvModalShown"
                   :sasv-id="editingSasvId"
                   @cancel="editSasvModalShown = false"
                   @finish="onEditSasvModalFinish"></EditSasvModal>
  </v-container>
</template>

<script>
import {onMounted, ref} from '@vue/composition-api';
import EditSasvModal from "@/components/sasv/EditSasvModal";

export default {
  name: 'SasvDuplicate',
  components: {EditSasvModal},
  setup(props, {root}) {
    const search = ref(null);
    const customFilter = function (value, search, item) {
      return item.name.toUpperCase().indexOf(search.toUpperCase()) !== -1;
    }
    const duplicates = ref([]);
    const headers = ref([
      {text: '', value: 'label', width: 'auto'},
      {text: '', value: 'data-table-expand', width: '20px'},
    ]);
    const expanded = ref([]);

    const sasvHeaders = ref([
      {text: root.$t('admin_sasv.octopus_no'), value: 'octopus_no'},
      {text: root.$t('admin_sasv.surname'), value: 'surname'},
      {text: root.$t('admin_sasv.given_name'), value: 'given_name'},
      {text: root.$t('admin_sasv.id_type'), value: 'id_type'},
      {text: root.$t('admin_sasv.company'), value: 'company.name'},
      {text: root.$t('admin_sasv.other_company_name'), value: 'other_company_name'},
      {text: root.$t('admin_sasv.status'), value: 'status', sortable: false},
      {text: root.$t('admin_sasv.validated_at'), value: 'validated_at', boolean: false},

      {text: '', value: 'actions', sortable: false},
    ]);

    const refresh = function () {
      root.$callAPI('sasv/admin/duplicates/', {}, function (response) {
        duplicates.value = response.body.duplicates;
      });
    };

    const exportUsers = function () {
      root.$callAPI('hkiarace/admin/user/export/', {}, function (response) {
        let blob = new Blob([response.data], {type: response.headers.get('content-type')});
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'users.xlsx';
        link.click();
      }, null, false, {responseType: 'arraybuffer'});
    };

    const editingSasvId = ref(null);
    const editSasvModalShown = ref(false);
    const onSasvEdit = function (item) {
      editingSasvId.value = item.id;
      editSasvModalShown.value = true;
    };
    const onEditSasvModalFinish = function () {
      editSasvModalShown.value = false;
      refresh();
    }
    const suspendItem = function (item) {
      if (confirm(root.$t('admin_sasv.suspend_confirm_msg'))) {
        root.$callAPI('sasv/admin/suspend/', {id: item.id}, () => {
          refresh();
        })
      }
    };
    const unsuspendItem = function (item) {
      if (confirm(root.$t('admin_sasv.unsuspend_confirm_msg'))) {
        root.$callAPI('sasv/admin/unsuspend/', {id: item.id}, () => {
          refresh();
        })
      }
    };

    onMounted(() => {
      refresh();
    })

    return {
      search,
      customFilter,
      duplicates,
      headers,
      expanded,
      sasvHeaders,

      refresh,

      exportUsers,

      editingSasvId,
      editSasvModalShown,
      onSasvEdit,
      onEditSasvModalFinish,
      suspendItem,
      unsuspendItem,
    }
  },
}
</script>

<style lang="less">
.admin-sasv-list {
  height: 100%;
  display: flex;
  flex-direction: column;

  .admin-member-main {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
